module.exports = __webpack_public_path__ + "img/mobile scanner stand42.c05afb99.jpg";